import React, { useEffect, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";

import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { LocalGasStation } from "@material-ui/icons";

import { NavItem } from "./NavItem";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBalanceScale,
  faBars,
  faCoins,
  faDollarSign,
  faDoorOpen,
  faMarker,
  faShoppingCart,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import { Theme } from "@material-ui/core/styles";
import ListItemText from "@material-ui/core/ListItemText";
import Grid from "@material-ui/core/Grid";
import ListItem from "@material-ui/core/ListItem";
import { TenantSelector } from "./TenantSelector";

const items = [
  {
    href: "/dashboard",
    icon: <FontAwesomeIcon icon={faBars} />,
    title: "Dashboard",
  },
  {
    href: "/estoque",
    icon: <FontAwesomeIcon icon={faBalanceScale} />,
    title: "Estoque",
  },
  {
    href: "/faturamento",
    icon: <FontAwesomeIcon icon={faCoins} />,
    title: "Faturamento",
  },
  {
    href: "/caixas",
    icon: <FontAwesomeIcon icon={faShoppingCart} />,
    title: "Caixas",
  },
  {
    href: "/precos",
    icon: <FontAwesomeIcon icon={faDollarSign} />,
    title: "Preços",
  },
  {
    href: "/encerrantes",
    icon: <FontAwesomeIcon icon={faMarker} />,
    title: "Encerrantes",
  },
  {
    href: "/statusBicos",
    icon: <LocalGasStation />,
    title: "Status dos Bicos",
  },
  {
    href: "/perfil",
    icon: <FontAwesomeIcon icon={faUser} />,
    title: "Meu Perfil",
  },

  {
    href: "/logout",
    icon: <FontAwesomeIcon icon={faDoorOpen} />,
    title: "Sair",
  },
];

const useStyles = makeStyles((theme: Theme) => ({
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    // justifyContent: 'flex-end',
  },
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: "calc(100% - 64px)",
  },
  avatar: {
    cursor: "pointer",
    width: 64,
    height: 64,
  },
}));

const getManifestObject = (): any => {
  var manifestObject = false;
  var xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      manifestObject = JSON.parse(xhr.responseText);
    }
  };
  xhr.open("GET", "/manifest.json", false);

  try {
    xhr.send();
  } catch (e) {
    console.log("Couldn't load manifest.json");
  }

  return manifestObject;
};

export const NavBar = ({
  onMobileClose,
  onMobileOpen,
  openMobile,
  user,
}: any) => {
  const classes = useStyles();
  const location = useLocation();

  const [appVersion, setAppVersion] = useState("?");

  useEffect(() => {
    var manifestData = getManifestObject();
    setAppVersion(manifestData.version);
  }, []);

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <Box alignItems="center" display="flex" flexDirection="column" p={2}>
        <Avatar
          className={classes.avatar}
          component={RouterLink}
          src={user.avatar}
          to="/perfil"
        />
        <Typography
          //className={classes.name}
          color="textPrimary"
          variant="body1"
        >
          {user.name ?? user.email}
        </Typography>
        <TenantSelector />
      </Box>
      <Divider />
      <Box p={2}>
        <List>
          {items.map((item) => (
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
            />
          ))}
        </List>
      </Box>
      <Box flexGrow={1} />
      {/* <Box
                p={2}
                m={2}
                bgcolor="background.dark"
            >
                <Typography
                    align="center"
                    gutterBottom
                    variant="h4"
                >
                    Need more?
        </Typography>
                <Typography
                    align="center"
                    variant="body2"
                >
                    Upgrade to PRO version and access 20 more screens
        </Typography>
                <Box
                    display="flex"
                    justifyContent="center"
                    mt={2}
                >
                    <Button
                        color="primary"
                        component="a"
                        href="https://react-material-kit.devias.io"
                        variant="contained"
                    >
                        See PRO version
          </Button>
                </Box>
            </Box> */}
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <SwipeableDrawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          onOpen={onMobileOpen}
          open={openMobile}
          variant="temporary"
        >
          <List>
            <ListItem>
              {/* <ListItemAvatar>
                                <Avatar>
                                    APC
                                </Avatar>
                            </ListItemAvatar> */}
              <ListItemText
                primary={
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <b style={{ fontSize: "1.1rem" }}>APC-MOBILE</b>
                    <span>{appVersion}</span>
                  </Grid>
                }
              />
            </ListItem>
          </List>
          <Divider />
          {content}
        </SwipeableDrawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};
